import React, { useCallback, useEffect, useState } from 'react'
import Layout from '../../layout/Layout'
import { Form, InputGroup, OverlayTrigger, Table, Tooltip } from 'react-bootstrap'
import CustomPagination from '../../components/CustomPagination';
import { Link } from 'react-router-dom';
import DeleteModal from '../../components/DeleteModal';
import ViewProducts from '../../components/products/ViewProducts';
import NoDateFound from '../../components/NoDateFound';
import Loader from '../../components/loader/Loader';
import { useGlobalState } from '../../context/GlobalStateContext';
import axiosInstance from '../../utils/axiosConfig';
import * as CustomToast from '../../components/CustomToastMessage';

function ProductsList() {
    const [products, setProducts] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [categories, setCategories] = useState([]);
    useEffect(() => {
        const fetchCategories = async () => {
            const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/categories/dropdown`);
            if (response.data.success) {
                console.log(response.data.data);
                setCategories(response.data.data);
            } else {
                setCategories([]);
            }
        };
        fetchCategories();
    }, []);

    const { loading, setLoading, search, pagination, setPagination, handleSearch, handleLimitChange } = useGlobalState()

    const fetchProducts = useCallback(async (page = 1, limit = 10, searchQuery = '', category = '') => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/products/list`, {
                params: {
                    page,
                    limit,
                    search: searchQuery,
                    category: category
                }
            });
            if (response.data.success) {
                setProducts(response.data.data);
                setPagination(response.data.pagination);
            } else {
                setProducts([]);
                setPagination(prev => ({
                    ...prev,
                    currentPage: 1,
                    totalPages: 1,
                    totalItems: 0
                }));
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
            setProducts([]);
            setPagination(prev => ({
                ...prev,
                currentPage: 1,
                totalPages: 1,
                totalItems: 0
            }));
        } finally {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setLoading, setPagination, selectedCategory])

    const handleDelete = async (id) => {
        try {
            setLoading(true);

            const response = await axiosInstance.delete(`${process.env.REACT_APP_BACKEND_URL}/api/admin/product/delete/${id}`);
            if (response.data.success) {
                CustomToast.success(response.data.message);
                fetchProducts(pagination.currentPage, pagination.limit, search);
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProducts(pagination.currentPage, pagination.limit, search, selectedCategory);
    }, [pagination.currentPage, pagination.limit, search, fetchProducts, selectedCategory]);

    const [trendingLoading, setTrendingLoading] = useState(false);

    const handleTrendingToggle = async (id, currentStatus) => {
        try {
            setTrendingLoading(true);
            const response = await axiosInstance.put(`${process.env.REACT_APP_BACKEND_URL}/api/admin/product/trending/${id}`, {
                trending: !currentStatus
            });
            if (response.data.success) {
                setProducts(prevProducts =>
                    prevProducts.map(product =>
                        product._id === id ? { ...product, trending: !currentStatus } : product
                    )
                );
                CustomToast.success(response.data.message);
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        } finally {
            setTrendingLoading(false);
        }
    };

    
    const [activeLoading, setActiveLoading] = useState(false);
    const handleToggleActiveStatus = async (id, currentStatus) => {
        try {
            setActiveLoading(true);
            const response = await axiosInstance.put(`${process.env.REACT_APP_BACKEND_URL}/api/admin/product/status/${id}`, {
                isShown: !currentStatus
            });
            if (response.data.success) {
                setProducts(prevProducts =>
                    prevProducts.map(product =>
                        product._id === id ? { ...product, isShown: !currentStatus } : product
                    )
                );
                CustomToast.success(response.data.message);
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        } finally {
            setActiveLoading(false);
        }
    };
    const handleCategoryChange = (value) => {
        setSelectedCategory(value);
        // fetchProducts(pagination.currentPage, pagination.limit, search);
    };

    return (
        <Layout title="Products List">
            <main>

                <div className="card page-card">
                    <div className="card-header d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                        <div className='d-flex align-items-center gap-3'>
                            <p>Show</p>
                            <Form.Select
                                aria-label="Default select example"
                                value={pagination.limit}
                                onChange={handleLimitChange}
                            >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                            </Form.Select>
                            <p>entries</p>
                        </div>

                        <div className='d-flex flex-column flex-md-row  align-items-start align-items-md-center gap-3 sm-w-100'>
                            <Form.Select
                                aria-label="Default select example"
                                value={selectedCategory}
                                onChange={(e) => handleCategoryChange(e.target.value)}
                                style={{ width: '180px' }}
                            >
                                <option value="">Select Category</option>
                                {categories.map((category) => (
                                    <option key={category._id} value={category._id}>{category.name}</option>
                                ))}
                            </Form.Select>
                            <div className='header-search'>
                                <InputGroup>
                                    <InputGroup.Text id="basic-addon1" className='bg-transparent'>

                                        <img src="/images/png/search.png" width={20} alt="" />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="search"
                                        className='border-start-0 ps-0'
                                        placeholder="search here..."
                                        value={search}
                                        onChange={handleSearch(fetchProducts)}
                                    />
                                </InputGroup>
                            </div>
                            <Link to="/products/add" className='btn-primary fs-16 fw-600 d-flex justify-content-center align-items-center gap-2 px-3'>
                                <img src="/images/png/plus.png" width={22} alt="" />
                                Add Product
                            </Link>
                            {/* <Link to="#" onClick={(e) => handleFetchProducts(e)} className='btn-primary fs-16 fw-600 d-flex justify-content-center align-items-center gap-2 px-3'>
                                Fetch Products
                            </Link> */}
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="overflow-auto">
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th width="40">Id</th>
                                        <th width="119">Image</th>
                                        <th>Title</th>
                                        {/* <th>Original Price</th>
                                        <th>Discount Price</th> */}
                                        <th>Link</th>
                                        <th width="300">Date</th>
                                        <th width="100">Status</th>
                                        <th className='text-center'>Trending</th>
                                        <th width="100" className='text-center'>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ?
                                        (<tr>
                                            <td colSpan="9" className="text-center">
                                                <Loader />
                                            </td>
                                        </tr>)
                                        : products.length > 0 ? (
                                            products.map((item, index) => (
                                                <tr key={item._id}>
                                                    <td>{(pagination.currentPage - 1) * pagination.limit + index + 1}</td>
                                                    <td>
                                                        <div className='table-border-image'>
                                                            <img src={item.productImage && item.productImage.length > 0 ? `${process.env.REACT_APP_BACKEND_URL}/${item.productImage[0]}` : "https://tse4.mm.bing.net/th?id=OIP.MDMViiwIZcTdBjbh46LQNwHaHa&w=800&h=800&rs=1&pid=ImgDetMain"} width={119} height={119} className='rounded-3 object-fit-cover img-sm-w' alt="" />
                                                        </div>
                                                    </td>
                                                    <td >
                                                        <p className='mb-0 table-td-300'>{item.name}</p>
                                                    </td>
                                                    {/* <td className='gray-text' width={150}> {item.price ? `$ ${item.price}` : "-"}</td>
                                                    <td className='gray-text' width={150}> {item.discount ? `$ ${item.discount}` : "-"}</td> */}
                                                    <td className='text-primary'>
                                                        <p className='mb-0 table-td-500'>{item.link ? item.link : "-"}</p>
                                                    </td>
                                                    <td >
                                                        <p className='mb-0 table-td-100'>{item.createdAt ? new Date(item.createdAt).toISOString().split('T')[0] : "-"}</p>
                                                    </td>
                                                    <td>
                                                        <div className='table-td-150 d-flex justify-content-center'>
                                                            <Form.Check
                                                                type="switch"
                                                                id={`active-switch-${item._id}`}
                                                                className='custom-switch'
                                                                checked={item.isShown || false}
                                                                
                                                                onChange={() => handleToggleActiveStatus(item._id, item.isShown)}
                                                                disabled={activeLoading}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='table-td-150 d-flex justify-content-center'>
                                                            <Form.Check
                                                                type="switch"
                                                                id={`trending-switch-${item._id}`}
                                                                className='custom-switch'
                                                                checked={item.trending || false}

                                                                onChange={() => handleTrendingToggle(item._id, item.trending)}
                                                                disabled={trendingLoading}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className='d-flex align-items-center gap-2'>
                                                            <ViewProducts product={item} />
                                                            <OverlayTrigger
                                                                key="top"
                                                                placement="top"
                                                                overlay={
                                                                    <Tooltip id="tooltip-top">
                                                                        Edit
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <Link to={`/products/edit/${item._id}`}>
                                                                    <img src="/images/png/edit.png" className="pointer" width={35} alt="action" />
                                                                </Link>
                                                            </OverlayTrigger>
                                                            <DeleteModal
                                                                onConfirm={() => handleDelete(item._id)}
                                                                loading={loading}
                                                                flag={"product"}
                                                            />
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))) : (
                                            <tr>
                                                <td colSpan="10" className="text-center">
                                                    <NoDateFound />
                                                </td>
                                            </tr>
                                        )}
                                </tbody>
                            </Table>
                        </div>
                        <CustomPagination
                            currentPage={pagination.currentPage}
                            totalPages={pagination.totalPages}
                            totalItems={pagination.totalItems}
                            limit={pagination.limit}
                            onPageChange={(page) => setPagination(prev => ({ ...prev, currentPage: page }))}
                        />
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default ProductsList